import script from "./TrapezoidDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrapezoidDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__